import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import { useConfigurationCallback } from '../hooks/useConfigurationCallback';
/**
 * This is a simple utility component which wraps an `MsalProvider` and
 * the `useConfigurationCallback` hook.
 */

export var TqAuthProvider = _ref => {
  var {
    instance,
    acquireTokenRequest,
    children
  } = _ref;
  // If we're already logged in, but for some reason the active account hasn't been set,
  // (probably because the user logged in using a previous version of @tq/auth-components)
  // set it to the first account in the list as a fail-safe. But generally it should be
  // set as a result of the login success event in useConfigurationCallback.
  var activeAccount = instance.getActiveAccount();
  var allAccounts = instance.getAllAccounts();

  if (activeAccount === null && allAccounts.length > 0) {
    instance.setActiveAccount(allAccounts[0]);
  }

  useConfigurationCallback(acquireTokenRequest, instance);
  return /*#__PURE__*/React.createElement(MsalProvider, {
    instance: instance
  }, children);
};